import styled from 'styled-components';
import { Grid } from '~/components';

export const GridStyled = styled(Grid)`
    border: 1px solid ${props => props.theme.colors.grey198};
    border-radius:22px;
    padding:16px;
`;